import React from 'react';
import { Tag } from 'antd';
import './index.less';
import classnames from 'classnames';

export enum ITagType {
  default = 'default',
  disabled = 'disabled',
  filled = 'filled',
  outlined = 'outlined',
}

export enum ITagFilledSize {
  small = 'small',
  middle = 'middle',
  large = 'large',
}

export interface IABSTagProps {
  filledSize?: ITagFilledSize;
  color?: string;
  content: string;
  visible?: boolean; // 对应type=[disabled|default]默认显示,其它type默认隐藏
  type?: ITagType;
}

interface IABSTagState {
  visible: boolean;
}

export class ABSTag extends React.Component<IABSTagProps, IABSTagState> {
  static defaultProps = {
    type: ITagType.default,
    filledSize: ITagFilledSize.middle,
  };

  constructor (props: IABSTagProps) {
    super(props);
    const { type, visible } = this.props;
    this.state = {
      visible: visible || (type === ITagType.default || type === ITagType.disabled)
    };
  }
  componentWillReceiveProps(nextprops: IABSTagProps) {
    const { visible } = nextprops;
    if (this.props.visible !== visible) {
       this.setState({visible: Boolean(visible)});
    }
  }
  render() {
    const { filledSize, color, content, type} = this.props;
    const { visible } = this.state;
    let style;
    let tagclass = classnames(`abs-tag-${type}`);
    let bgColor = color ? color : '';
    if (type === ITagType.outlined) {
      style = { color: `${color}`, border: `1px solid ${color}`};
      bgColor = '';
    } else if (type === ITagType.filled) {
      tagclass = classnames(`abs-tag-${type} abs-tag-${filledSize}`);
    }

    return (
      <>
      {
        visible ? (
          <div className="abs-tag">
            <Tag
              color={bgColor}
              className={tagclass}
              style={style}
            >
              {content}
            </Tag>
          </div>
        ) : null
      }
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSTag/index.tsx